import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-16 border-t border-background-200/70 bg-background-100">
      <div className="px-4 py-12 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-play-circle-fill text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">
                97<span className="text-accent-500">视频</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-500">
              97视频是一个综合影视内容在线观看平台，聚合电影、电视剧、综艺节目等优质资源，
              致力于为用户带来高清、便捷、舒适的观影体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">
              <Link to="/category/movie" className="cursor-pointer hover:text-accent-500">
                影视分类
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-500">
              <li>
                <Link to="/category/movie" className="cursor-pointer hover:text-foreground-900">
                  电影频道
                </Link>
              </li>
              <li>
                <Link to="/category/tv" className="cursor-pointer hover:text-foreground-900">
                  电视剧频道
                </Link>
              </li>
              <li>
                <Link to="/category/variety" className="cursor-pointer hover:text-foreground-900">
                  综艺频道
                </Link>
              </li>
              <li>
                <Link to="/search" className="cursor-pointer hover:text-foreground-900">
                  全站搜索
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">
              <Link to="/about" className="cursor-pointer hover:text-accent-500">
                关于我们
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-500">
              <li>
                <Link to="/about" className="cursor-pointer hover:text-foreground-900">
                  网站介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="cursor-pointer hover:text-foreground-900">
                  联系我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="cursor-pointer hover:text-foreground-900">
                  免责声明
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200/70 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 97视频 · 本站内容均为演示数据，不提供任何真实影视播放与下载服务。</p>
          <p className="flex flex-wrap gap-4">
            <span className="cursor-pointer hover:text-foreground-800">服务条款</span>
            <span className="cursor-pointer hover:text-foreground-800">隐私政策</span>
            <span className="cursor-pointer hover:text-foreground-800">版权声明</span>
          </p>
        </div>
      </div>
    </footer>
  );
}